import { useNotifications } from '@/hooks/useNotifications';
import { X, CreditCard, ShoppingCart } from 'lucide-react';
import { Link } from 'wouter';

export function NotificationPopup() {
  const { showPopup, currentNotification, closePopup } = useNotifications();

  if (!showPopup || !currentNotification) return null;

  const isCreditNotification = ['credit_low', 'credit_out', 'credit_bonus_offer', 'credit_purchase'].includes(currentNotification.type);

  const getNotificationIcon = () => {
    switch (currentNotification.type) {
      case 'bio_like':
        return '❤️ Nuovo Like';
      case 'interest_like':
        return '💕 Interessi Condivisi';
      case 'photo_like':
        return '📸 Foto Apprezzata';
      case 'new_message':
        return '💬 Nuovo Messaggio';
      case 'gift_received':
        return '🎁 Hai ricevuto un regalo';
      case 'credit_low':
        return '⚠️ Crediti in esaurimento';
      case 'credit_out':
        return '🚨 Crediti terminati';
      case 'credit_purchase':
        return '✅ Acquisto Completato';
      default:
        return '🔔 Nuova Notifica';
    }
  };

  return (
    <div className="fixed top-20 right-4 z-50 animate-in slide-in-from-right-full duration-300">
      <div className={`rounded-lg shadow-lg border p-4 max-w-sm ${isCreditNotification
          ? 'bg-gradient-to-br from-yellow-50 to-orange-50 border-yellow-300 dark:from-yellow-900/20 dark:to-orange-900/20 dark:border-yellow-700'
          : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700'
        }`}>
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <div className={`w-2 h-2 rounded-full animate-pulse ${isCreditNotification ? 'bg-yellow-500' : 'bg-pink-500'
                }`}></div>
              <p className={`text-sm font-medium ${isCreditNotification
                  ? 'text-yellow-900 dark:text-yellow-100'
                  : 'text-gray-900 dark:text-white'
                }`}>
                {getNotificationIcon()}
              </p>
            </div>
            <p className={`text-sm font-medium mb-3 ${isCreditNotification
                ? 'text-yellow-800 dark:text-yellow-200'
                : 'text-gray-600 dark:text-gray-300'
              }`}>
              {currentNotification.message}
            </p>

          </div>
          <button
            onClick={closePopup}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Progress bar for auto-close */}
        <div className={`mt-3 w-full rounded-full h-1 ${isCreditNotification ? 'bg-yellow-200 dark:bg-yellow-800' : 'bg-gray-200 dark:bg-gray-700'
          }`}>
          <div
            className={`h-1 rounded-full ${isCreditNotification ? 'bg-yellow-500' : 'bg-pink-500'
              }`}
            style={{
              animation: 'progress 5s linear forwards'
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes progress {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
}